import httpClient from '../../services/http-client';
import { API_SUB_URL_ENTERPRISE } from '../../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from '../actions';
import { 
    FETCH_DATA_REQUEST, FETCH_DATA_ERROR,
    ADD_NEW_ENTERPRISE, LOAD_LIST_ENTERPRISE, LOAD_A_ENTERPRISE, UPDATE_A_ENTERPRISE, DELETE_A_ENTERPRISE
} from '../actionTypes';

export const apiLoadListEnterprise = (params) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));
        
        let query = "";

        Object.keys(params).map(key => {
            if(params[key]) {
                query += (query.length > 0 ? "&&" : "") + (`${key}=` + params[key]);
            }
        });

        httpClient.get(`${API_SUB_URL_ENTERPRISE}?${query}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_ENTERPRISE, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadAEnterprise = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_ENTERPRISE}/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_ENTERPRISE, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiCreateNewEnterprise = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(API_SUB_URL_ENTERPRISE, payload)
            .then(response => {
                dispatch(fetchDataSuccess(ADD_NEW_ENTERPRISE, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiUpdateAEnterprise = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.put(`${API_SUB_URL_ENTERPRISE}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_A_ENTERPRISE, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiDeleteAEnterprise = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(`${API_SUB_URL_ENTERPRISE}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_A_ENTERPRISE, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};